<template> 
  <router-view/>
</template>
<script>  
export default { 
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.initialRatio(document.body.clientWidth);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      this.resizeTimer = setTimeout(() => {
        this.initialRatio(document.body.clientWidth);
      }, 600);
    },
    initialRatio(width = 1920) {
      const ratioWidth = width / 1920;
      const appDom = document.getElementById('app');
      if (appDom) {
        appDom.style.removeProperty('transform');
        appDom.style.transform = `scale(${ratioWidth})`;
      }
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
